import { Component, OnInit, forwardRef, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';

import { 
    IonIcon
} from '@ionic/angular/standalone';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

import { ShopFilterComponent, ShopFilterItem } from '@app/components';
import { DataService } from '@app/services';

export class ShopFiltersValues {
    products: Array<string> = [];
    levels: Array<number> = [];
    costsInPoints: Array<number> = [];
}

@Component({
    selector: 'app-shop-filters',
    templateUrl: './filters.component.html',
    styleUrls: ['./filters.component.scss'],
    imports: [
        IonIcon, TranslatePipe, forwardRef(() => ShopFilterComponent)
    ]
})
export class ShopFiltersComponent  implements OnInit {
      
    @Input({alias : 'shopFiltersValues', required : false}) shopFiltersValues: ShopFiltersValues = new ShopFiltersValues();
    @Output() onChangeFilters = new EventEmitter<ShopFiltersValues>();
     
    products: Array<ShopFilterItem> = [];
    levels: Array<ShopFilterItem> = [];
    costsInPoints: Array<ShopFilterItem> = [];
    
    constructor(             
        public translateService: TranslateService,
        public dataService: DataService
    ) { }

    ngOnInit() {
        let products: Array<ShopFilterItem> = [];
        let levels: Array<ShopFilterItem> = this.dataService.operation.levels?.map((l:any, index: number) => new ShopFilterItem(index, l.name)) || [];
        let costsInPoints: Array<ShopFilterItem> = [];
        this.dataService.operation.shop.products.forEach(product => {      
            products.push(new ShopFilterItem(product.ID, product.title));            
            if(product.costInPoints !== null && !costsInPoints.find(c => c.id === product.costInPoints)){
                costsInPoints.push(new ShopFilterItem(product.costInPoints, this.translateService.instant('SHOP.PRODUCT_COST').replace('{nb_points}', product.costInPoints)));
            }
        });        
        products.sort((a, b) => a.label.localeCompare(b.label));
        levels.sort((a, b) => a.id - b.id);
        costsInPoints.sort((a, b) => a.id - b.id);
        
        this.products = products;
        this.levels = levels;
        this.costsInPoints = costsInPoints;
    }
    
    async ngOnChanges(changes: SimpleChanges) {
        
    }
    
    onChangeFilterProducts(values: Array<ShopFilterItem>){
        this.shopFiltersValues.products = values.map(v => v.id);
        this.onChangeFilters.emit(this.shopFiltersValues);
    }
    
    onChangeFilterLevels(values: Array<ShopFilterItem>){
        this.shopFiltersValues.levels = values.map(v => v.id);
        this.onChangeFilters.emit(this.shopFiltersValues);
    }
    
    onChangeFilterCostsInPoints(values: Array<ShopFilterItem>){
        this.shopFiltersValues.costsInPoints = values.map(v => v.id);
        this.onChangeFilters.emit(this.shopFiltersValues);
    }
}
